<template>
  <p class="loading">
    <b-spinner variant="primary" label="Spinning"></b-spinner>
    لطفا صبر کنید...
  </p>
</template>

<script>
export default {
  name: "Loading"
};
</script>

<style>
.loading {
  text-align: center;
  color: #17a2b8;
  direction: rtl;
  margin: 0;
}
</style>
